import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Toast } from 'react-weui';
import SendSmscode from 'components/sendSmscode.js';
import Http from 'services/http2';
import Validation from 'services/validation';
import AreaCode from 'components/areaCode';
import User from 'services/user2';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  button: {
    width: '100%',
    height: '50px',
    fontSize: '16px',
  },
});

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      showLoading: false,
      mobile: '',
      areaCode: '+86',
      password: '',
      smsCode: '',
      nickName: '',
    };
    this.dialogMsg = '';
    this.mobile = '';
    this.areaCode = '+86';
    this.smsCode = '';
    this.password = '';
    this.validationConfig = this.validationConfig.bind(this);
    this.error = {};
  }

  init() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  validationConfig() {
    let obj = {
      '+86': 'mobile',
      '+852': 'mobile8',
      '+853': 'mobile8',
      '+886': 'mobile9',
    };
    let rule = obj[this.areaCode];
    return {
      mobile: { value: this.mobile, rules: ['required', rule] },
      smsCode: { value: this.smsCode, rules: ['required', 'smsCode'] },
      password: { value: this.password, rules: ['required', 'password'] },
    };
  }

  areaCodeChange = code => {
    this.areaCode = code;
    this.setState({ areaCode: code });
  };

  handleInputBlur = name => event => {
    let valid = Validation.validate(this.validationConfig(), name, this.error);
    if (!valid) {
      this.setState({ error: true });
    }
  };

  //检查验证码
  chekAuthCode() {
    let postbody = {
      mobile: this.mobile,
      mobileArea: this.areaCode,
      authCode: this.smsCode,
      apiPath: '/sms/chekAuthCode',
    };
    Http.post('/api/user', postbody).then(response => {
      if (!response.success) {
        this.error['smsCode'] = response.errorMsg;
        this.setState({ error: true });
      }
    });
  }

  //检查手机唯一性
  checkMobile() {
    let postbody = {
      mobile: this.mobile,
      mobileArea: this.areaCode,
      apiPath: '/sysUser/valifyRegMobile',
    };
    Http.post('/api/user', postbody).then(response => {
      if (!response.success) {
        this.error['mobile'] = response.errorMsg;
        this.setState({ error: true });
      }
    });
  }

  register() {
    if (!Validation.validateAll(this.validationConfig(), this.error)) {
      this.setState({ error: true });
      return;
    }
    this.setState({ showLoading: true });
    let postbody = {
      mobile: this.mobile,
      mobileArea: this.areaCode,
      password: this.password,
      smsCode: this.smsCode,
      email: '',
      nickName: this.mobile,
      apiPath: '/sysUser/register',
    };
    Http.post('/api/mp', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        let userInfo = response.data.sysUser;
        User.setUserInfo(userInfo);
        this.props.history.push('/mp/create-company');
      } else {
        this.error['password'] = response.errorMsg;
        this.setState({ error: true });
      }
    });
  }

  handleChange = name => event => {
    let valid = false;
    let val = event.target.value.trim();
    this[name] = val;
    this.error[name] = undefined;
    this.setState({
      [name]: val,
    });
    switch (name) {
      case 'mobile':
        valid = Validation.validate(this.validationConfig(), name, this.error);
        if (valid && [8, 9, 11].indexOf(val.length) > -1) {
          this.checkMobile();
        }
        break;
      case 'smsCode':
        valid = Validation.validate(this.validationConfig(), name, this.error);
        if (valid) {
          this.chekAuthCode();
        }
        break;
      case 'password':
        break;
      default:
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="page page-register">
        <div className="container">
          <div className="m-logo">
            <img src="/assets/img/logo@2x.png" alt="" />
            <span className="label">注册携客账号</span>
          </div>
          <div className="input-item input-mobile">
            <TextField
              id="outlined-mobile"
              label="手机号"
              className="text-field"
              value={this.mobile}
              onChange={this.handleChange('mobile')}
              onBlur={this.handleInputBlur('mobile')}
              margin="normal"
              variant="outlined"
            />
            <AreaCode onChange={this.areaCodeChange} />
            {this.error['mobile'] && (
              <p className="error-tip">{this.error['mobile']}</p>
            )}
          </div>
          <div className="input-item">
            <TextField
              id="outlined-smsCode"
              label="短信验证码"
              className="text-field"
              value={this.smsCode}
              onChange={this.handleChange('smsCode')}
              onBlur={this.handleInputBlur('smsCode')}
              margin="normal"
              variant="outlined"
            />
            <SendSmscode
              areaCode={this.areaCode}
              mobile={this.mobile}
              smsType="1"
            />
            {this.error['smsCode'] && (
              <p className="error-tip">{this.error['smsCode']}</p>
            )}
          </div>
          <div className="input-item">
            <TextField
              id="outlined-password"
              label="密码"
              type="password"
              className="text-field"
              value={this.password}
              onChange={this.handleChange('password')}
              onBlur={this.handleInputBlur('password')}
              margin="normal"
              variant="outlined"
            />
            {this.error['password'] && (
              <p className="error-tip">{this.error['password']}</p>
            )}
          </div>
          <div className="input-item">
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.register()}
              className={classes.button}
            >
              注 册
            </Button>
          </div>
          <div className="input-item tr">
            已有账号？
            <Link to="/mp/login">直接登陆</Link>
          </div>
        </div>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Register);
